module.exports = __webpack_public_path__ + "static/media/Webstorm.fb7de0de.png";